import {SettingOutlined} from '@ant-design/icons'
import Settings from './Settings.jsx'

export default items => {
    return {
        icon: <SettingOutlined />,
        key: 'settings',
        name: '设置',
        pane: <Settings items={items} />,
    }
}
